import {json} from '../../../core/data-source/json.mapper';

export enum VehicleCheckFieldType {
    CHECK = 'CHECK',
    SINGLE_LINE = 'SINGLE_LINE',
    MULTI_LINE = 'MULTI_LINE',
    NUMBER = 'NUMBER',
    PHOTO = 'PHOTO',
    DROPDOWN = 'DROPDOWN'
}

export class VehicleChecksReportListFieldsRecord {
    @json()
    name: string;

    @json()
    value: string;

    @json()
    type: VehicleCheckFieldType;

    @json()
    comment: string;

    @json()
    photos: string[];

    @json({
        skip: true,
        value: false
    })
    visible: boolean;
}
